import React from 'react';

const parseAvailability = value => {
  const text = String(value ?? '').trim();
  if (!text || /n\/a|—|--/i.test(text)) return null;

  const full = text.match(/(\d+)\s*(?:Full|F)\b/i);
  const partial = text.match(/(\d+)\s*(?:Partial|P)\b/i);

  if (full) {
    return {
      full: Number(full[1]),
      partial: partial ? Number(partial[1]) : 0,
    };
  }

  const n = Number(text);
  return Number.isFinite(n) ? { full: n, partial: 0 } : null;
};

const availabilityClass = value => {
  const counts = parseAvailability(value);
  if (!counts) return 'pub-neutral';
  if (counts.full === 0 && counts.partial > 0) return 'pub-warn';
  if (counts.full === 0) return 'pub-bad';
  if (counts.full <= 3) return 'pub-warn';
  return 'pub-good';
};

const mandoClass = value => {
  const n = Number(value);
  if (!Number.isFinite(n)) return 'pub-neutral';
  if (n > 0) return 'pub-bad';
  return 'pub-neutral';
};

const vacancyClass = value => {
  const n = Number(value);
  if (!Number.isFinite(n)) return 'pub-neutral';
  if (n > 0) return 'pub-bad';
  return 'pub-neutral';
};

const brownoutClass = value => {
  const text = String(value ?? '').trim();
  if (!text || /^(?:N\/A|--|—|None)$/i.test(text)) return 'pub-neutral';
  return 'pub-bad';
};

const cellClass = (header, value) => {
  if (/Brownout/i.test(header)) return brownoutClass(value);
  if (/MCB|Mando|Mandatory/i.test(header)) return mandoClass(value);
  if (/\bVac\b|Vacancy|Vacancies/i.test(header)) return vacancyClass(value);
  if (/Avail/i.test(header)) return availabilityClass(value);
  return '';
};

export default function GeneralTable({ general, compact = false }) {
  const headers = general?.headers || [];

  return (
    <div className="pub-table-wrap">
      <table className={`pub-table${compact ? ' pub-table-compact' : ''}`}>
        <thead>
          <tr>{headers.map(h => <th key={h}>{h}</th>)}</tr>
        </thead>
        <tbody>
          {(general?.rows || []).map((row, i) => (
            <tr key={i}>
              {headers.map((h, j) => (
                <td key={h} className={cellClass(h, row[h])}>
                  {row[h] || (j ? '—' : '')}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
